import classes from './profileSettingsErrCard.scss';

const PSErrCard = (props) => {
  let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  return (
    <div className={classes.errorBanner}>
      <div className={classes.errorMessageContainer}>
        <div className={classes.errorMessage}>
          <p className={classes.errorImage}><img src={warningImg} alt="Warning Image" /></p>
            <div className={classes.group2}>
                <div className={classes.notificationLabel}>{'Something went wrong on our end.'}</div>
                <div className={classes.somethingWrong}><a href="#" onClick={props.onFormhandler}>Click here to resubmit</a></div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default PSErrCard;